/**
 * @fileoverview A function that provides the studies API.
 *
 * @example
 * const { result } = renderHook(() => useStudiesAPI())
 */

import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './utils/axiosBaseQuery'

export const studiesApi = createApi({
    reducerPath: 'studiesApi',
    baseQuery: axiosBaseQuery({ baseUrl: `/private/studies` }),
    endpoints: (builder) => ({
        getStudies: builder.query<Novoic.API.Study[], string | void>({
            query: (search = '') => {
                return {
                    url: `?${search}`,
                    method: 'GET',
                }
            },
        }),

        getStudiesCount: builder.query<{ count: number }, void>({
            query: () => {
                const sp = new URLSearchParams(location.search)
                return {
                    url: `/count?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),

        getStudyById: builder.query<Novoic.API.Study, string>({
            query: (id: string) => {
                const sp = new URLSearchParams(location.search)
                return {
                    url: `/${id}?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),
    }),
})

export const { useGetStudiesQuery, useGetStudiesCountQuery, useGetStudyByIdQuery } = studiesApi
